import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarLayoutService {
  public readonly sidebarOpen$: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );

  public openSidebar(): void {
    if (!this.sidebarOpen$.value) {
      this.sidebarOpen$.next(true);
    }
  }

  public closeSidebar(): void {
    if (this.sidebarOpen$.value) {
      this.sidebarOpen$.next(false);
    }
  }
}
